export default __webpack_public_path__ + "static/media/ic_dashboard.a3b414d3.svg";